/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddReferenceableAndCopySubscribersRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AddReferenceableAndCopySubscribersResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const addReferenceableAndCopySubscribers = (request:AddReferenceableAndCopySubscribersRequest, options?: CashRequestOptions) => post<AddReferenceableAndCopySubscribersRequest, AddReferenceableAndCopySubscribersResponse>("/2.0/cash/add-referenceable-and-copy-subscribers", request, {...options, rejectOnError: true })